import React from "react";
import { Container, Text } from "style/global.styled";
import styled from "styled-components";
import { useTranslation } from "react-i18next";

const Cont = styled(Container)`
  min-height: 70vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
`;

const Wrapper = styled.div`
  display: grid;
  width: 80%;
  margin: 30px auto;
  min-width: 1300px;
  letter-spacing: 1px;
  grid-template-columns: repeat(5, 1fr);
  @media (max-width: 1300px) {
    min-width: 900px;
    grid-template-columns: repeat(3, 1fr);
  }
  @media (max-width: 900px) {
    min-width: 600px;
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    width: 100%;
    min-width: unset;
    grid-template-columns: 1fr;
    margin: 0 auto;
  }
`;

const Title = styled.div`
  font-weight: bold;
  font-size: 23px;
  margin-bottom: 15px;
  color: ${props => props.theme.colors.orange};
`;

const InfoContainer = styled.div`
  padding: 20px 40px 20px 20px;
  min-width: 230px;
  position: relative;
  :after {
    content: "";
    position: absolute;
    top: 50%;
    right: 0;
    width: 2px;
    height: 70%;
    transform: translateY(-50%);
    background: ${props => props.theme.colors.transparentSecondary};
  }
  :last-child:after {
    display: none;
  }
  @media (max-width: 1300px) {
    :nth-child(3):after {
      display: none;
    }
  }
  @media (max-width: 900px) {
    :nth-child(2):after {
      display: none;
    }
    :nth-child(3):after {
      display: initial;
    }
    :nth-child(4):after {
      display: none;
    }
    :last-child:after {
      display: initial;
    }
  }
  @media (max-width: 600px) {
    padding: 25px 10px;
    text-align: center;
    :after {
      display: none !important;
    }
  }
`;

const InfoText = styled.div`
  margin: 5px 0;
  font-size: 20px;
  color: ${props => props.theme.colors.secondary};
  span {
    font-weight: bold;
  }
`;

const SubText = styled(InfoText)`
  margin: 25px auto;
  text-align: center;
  padding: 20px;
  font-size: 25px;
  span {
    font-weight: bold;
    color: ${props => props.theme.colors.orange};
  }
  @media (max-width: 1300px) {
    min-width: unset;
  }
  @media (max-width: 600px) {
    font-size: 20px;
    text-align: justify;
  }
`;

const TextContainer = styled.div`
  text-align: justify;
  ${Text} {
    margin: 30px 0;
    max-width: 70%;
    span {
      font-weight: bold;
    }
    @media (max-width: 1024px) {
      max-width: 100%;
    }
  }
`;

const Contact = () => {
  const { t: translate } = useTranslation();

  return (
    <Cont>
        <TextContainer>
        {translate("contact.texts", { returnObjects: true }).map(
            (text, index) => (
              <SubText key={index}>{text}</SubText>
            )
          )}
          <SubText>
            <div>
              {translate("contact.rooms")}
            </div>
            <div>
              {translate("contact.small")}
            </div>
            <div>
              {translate("contact.cellar")}
            </div>
            <div>
              {translate("contact.big")}
            </div>
            <div>
              {translate("contact.all")}
            </div>
          </SubText>
        </TextContainer>
      <Wrapper>
        {translate("contact.info", { returnObjects: true }).map(
          (info, index) => (
            <InfoContainer key={index}>
              <Title>{info.title}</Title>
              {info.texts.map((text, index) => (
                <InfoText key={index}>
                  {text.bold && <span>{text.bold}</span>}
                  {text.normal}
                </InfoText>
              ))}
            </InfoContainer>
          )
        )}
      </Wrapper>
    </Cont>
  );
};

export default Contact;
